<template>
  <svg
    width="35"
    height="32"
    viewBox="0 0 32 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="house icon">
      <path
        id="Vector"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.6157 9.74267L16.1993 1.82672L5.78291 9.74267V22.4785C5.78291 23.8715 6.90468 25.0041 8.29353 25.0041H24.1092C25.4939 25.0041 26.6198 23.8756 26.6198 22.4785V9.74267H26.6157Z"
        fill="var(--icon-secondary, #43386040)"
      />
      <path
        id="Vector_2"
        d="M2.02315 12.6941L16.2034 1.82672L30.3795 12.69"
        stroke="var(--icon-primary, var(--grey800))"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
